module.exports = __webpack_public_path__ + "static/media/julesCoffret.7735e4cc.png";